export default __webpack_public_path__ + "static/media/angle-double-left.37f3c76a.svg";